// automatically generated by the FlatBuffers compiler, do not modify

export enum UnionMode{
  Sparse = 0,
  Dense = 1
}

